import { useQuery } from "@tanstack/react-query";
import {
  listOpportunities,
  getFilters,
  getCounts,
} from "../api/opportunities";
import {
  CategoryType,
  OpportunityItem,
  Page,
  OpportunityCounts,
  CategoryFilterResponse,
} from "../types";
import { queryKeys } from "./queryKeys";

export const useOpportunities = (
  type: CategoryType,
  page: number,
  size: number,
  categoryFilters?: string[]
) =>
  useQuery<Page<OpportunityItem>>({
    queryKey: [queryKeys.OPPORTUNITY_LIST, type, page, size, categoryFilters],
    queryFn: () => listOpportunities(type, page, size, categoryFilters),
  });

export const useOpportunityFilters = (type: CategoryType, all = false) =>
  useQuery<CategoryFilterResponse[]>({
    queryKey: [
      all ? queryKeys.OPPORTUNITY_FILTERS_ALL : queryKeys.OPPORTUNITY_FILTERS,
      type,
    ],
    queryFn: () => getFilters(type, all),
  });

export const useOpportunityCounts = () =>
  useQuery<OpportunityCounts>({
    queryKey: [queryKeys.OPPORTUNITY_COUNTS],
    queryFn: getCounts,
  });
